<!--
 * @description: 数据加载过程中默认的展示页面
 * @author: zb
 * @update: zb
 * @Date: 2019-07-03 09:02:37
 * @LastEditors: zb
 * @LastEditTime: 2019-07-03 10:20:54
 -->
<template>
  <div class="ant-card-loading-content">
    <div class="el-row" style="margin-left: -4px; margin-right: -4px;">
      <div class="el-col el-col-22" style="padding-left: 4px; padding-right: 4px;">
        <div class="ant-card-loading-block" />
      </div>
    </div>
    <div class="el-row" style="margin-left: -4px; margin-right: -4px;">
      <div class="el-col el-col-8" style="padding-left: 4px; padding-right: 4px;">
        <div class="ant-card-loading-block" />
      </div>
      <div class="el-col el-col-15" style="padding-left: 4px; padding-right: 4px;">
        <div class="ant-card-loading-block" />
      </div>
    </div>
    <div class="el-row" style="margin-left: -4px; margin-right: -4px;">
      <div class="el-col el-col-6" style="padding-left: 4px; padding-right: 4px;">
        <div class="ant-card-loading-block" />
      </div>
      <div class="el-col el-col-18" style="padding-left: 4px; padding-right: 4px;">
        <div class="ant-card-loading-block" />
      </div>
    </div>
    <div class="el-row" style="margin-left: -4px; margin-right: -4px;">
      <div class="el-col el-col-13" style="padding-left: 4px; padding-right: 4px;">
        <div class="ant-card-loading-block" />
      </div>
      <div class="el-col el-col-9" style="padding-left: 4px; padding-right: 4px;">
        <div class="ant-card-loading-block" />
      </div>
    </div>
    <div class="el-row" style="margin-left: -4px; margin-right: -4px;">
      <div class="el-col el-col-4" style="padding-left: 4px; padding-right: 4px;">
        <div class="ant-card-loading-block" />
      </div>
      <div class="el-col el-col-3" style="padding-left: 4px; padding-right: 4px;">
        <div class="ant-card-loading-block" />
      </div>
      <div class="el-col el-col-16" style="padding-left: 4px; padding-right: 4px;">
        <div class="ant-card-loading-block" />
      </div>
    </div>
    <div class="el-row" style="margin-left: -4px; margin-right: -4px;">
      <div class="el-col el-col-8" style="padding-left: 4px; padding-right: 4px;">
        <div class="ant-card-loading-block" />
      </div>
      <div class="el-col el-col-6" style="padding-left: 4px; padding-right: 4px;">
        <div class="ant-card-loading-block" />
      </div>
      <div class="el-col el-col-8" style="padding-left: 4px; padding-right: 4px;">
        <div class="ant-card-loading-block" />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'LoadAbleCard'
}
</script>
<style lang="scss" scoped>
$ant-perfix: "ant";
$card-prefix-cls: "ant-card";
$card-head-height: 48px;
$gradient-min: rgba(207, 216, 220, 0.2);
$gradient-max: rgba(207, 216, 220, 0.4);
$card-radius: 2px;

.ant-card-loading-content {
  .#{$card-prefix-cls} {
    &-loading {
      overflow: hidden;
    }

    &-loading &-body {
      user-select: none;
    }

    &-loading-content {
      p {
        margin: 0;
      }
    }

    &-loading-block {
      height: 14px;
      margin: 4px 0;
      background: linear-gradient(
        90deg,
        $gradient-min,
        $gradient-max,
        $gradient-min
      );
      background-size: 600% 600%;
      border-radius: $card-radius;
      animation: card-loading 1.4s ease infinite;
    }

    @keyframes card-loading {
      0%,
      100% {
        background-position: 0 50%;
      }
      50% {
        background-position: 100% 50%;
      }
    }
  }
}
</style>

